import { setEvents } from "./analyticsEvents";
import ApiKeys from "../config/apiKeys";

const metaApiKey = ApiKeys.META_EVENTS_KEY;
const appVersion = ApiKeys.APP_VERSION;

function initializeFacebookPixel(pixelId) {
  if (!pixelId) {
    return;
  }

  // Initialize the script tag for Facebook Pixel
  (function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  // Initialize Facebook Pixel with the provided Pixel ID
  fbq('init', pixelId);
  window.metaEventsTemp?.forEach((metaEventTemp) => {
    window.fbq("track", metaEventTemp.event);
  });
  window.metaEventsTemp = [];

  // Add a noscript fallback image
  var noscript = document.createElement('noscript');
  noscript.innerHTML = '<img height="1" width="1" style="display:none" ' +
    'src="https://www.facebook.com/tr?id=' + pixelId + '&ev=PageView&noscript=1"/>';
  document.body.appendChild(noscript);
}

export const initializeMetaTime = async () => {
  initializeFacebookPixel(metaApiKey);
  setEvents("meta", "App Open", { eventObj: "demo" });
};
